module.exports = "https://trybtryb-legacy.web.app/img/business-school.6cea1801.svg";